<template>
  <div>
    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/1 w-full">
        <vx-card>
          <h3>Adicionar Regras de Envio E-mail / SMS</h3>
          <div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <FormMensageria
                  :idDistribuidor="decoded.idDistribuidor"
                  :objUpdate="null"
                  @add="buscaDados()"
                />
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-alert
                  v-if="regras.length == 0"
                  icon="warning"
                  title="Atenção!!"
                  active="true"
                  color="danger"
                  class="my-5"
                >
                  Nenhuma Regra Encontrada</vs-alert
                >
                <table class="table table-bordered" v-else>
                  <tr>
                    <th class="uppercase text-center">Id</th>
                    <th class="uppercase">Evento</th>
                    <th class="uppercase">Tipo</th>
                    <th class="uppercase">Assunto</th>
                    <th class="uppercase">Padrão</th>
                    <th class="uppercase">Ações</th>
                  </tr>
                  <tr v-for="item in regras" :key="item.id">
                    <td class="text-center">
                      {{ item.idPadrao }}
                    </td>
                    <td>
                      {{ item.evento }}
                    </td>
                    <td>{{ item.tipo }}</td>
                    <td>{{ item.assunto }}</td>
                    <td>{{ item.padrao }}</td>
                    <td>
                      <vs-button
                        v-tooltip="'Editar'"
                        radius
                        color="primary"
                        type="gradient"
                        icon-pack="feather"
                        icon="icon-edit"
                        class="d-inline"
                        @click="opemModalUpdate(item)"
                      ></vs-button>
                      <vs-button
                        v-if="item.idPadrao"
                        v-tooltip="'Deletar'"
                        radius
                        color="danger"
                        type="gradient"
                        icon-pack="feather"
                        icon="icon-minus"
                        class="d-inline"
                        @click="openModalDelete(item.idPadrao)"
                      ></vs-button>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>

    <vs-popup
      class="holamundo"
      :title="'Deletar'"
      :active.sync="popDeleteArvore"
      @close="popDeleteArvore = false"
    >
      Tem certeza que deseja deletar a regra?<br />
      <vs-button @click="deleteArvore()" color="danger" class="mb-2 my-5 ml-2">
        <span>sim, Deletar</span>
      </vs-button>
    </vs-popup>
    <vs-popup
      class="holamundo"
      :title="'Atualizar Regra'"
      :active.sync="popUpdate"
      @close="popUpdate = false"
    >
      <FormMensageria
        :objUpdate="objUpdate"
        :idDistribuidor="decoded.idDistribuidor"
        @add="buscaDados()"
      />
    </vs-popup>
  </div>
</template>

<script>
import service from "./../../../../services";
import locale from "./../../../../locale";
import Datepicker from "vuejs-datepicker";
import { Money } from "v-money";
import moment from "moment";
import BotaoSubmit from "./../../../../components/BotaoSubmit";
import FormMensageria from "./FormMensageria.vue";
import utilsList from "./../../../../utils/list";
export default {
  components: {
    Datepicker,
    Money,
    BotaoSubmit,
    FormMensageria,
  },
  data() {
    return {
      utilsList,
      decoded: utilsList.buscaToken(),
      aguardeCadastro: false,
      regras: [],
      listProdutos: [],
      objUpdate: null,
      idDelete: null,
      popDeleteArvore: false,
      popUpdate: false,
      passo: 0,
      dadosDistribuidor: null,
    };
  },
  methods: {
    opemModalUpdate(obj) {
      this.popUpdate = true;
      this.objUpdate = obj;
      console.log(this.objUpdate);
    },
    openModalDelete(id) {
      this.popDeleteArvore = true;
      this.idDelete = id;
    },
    atualizaLista(obj) {
      this.status.push(obj);
    },
    filtraArray(tipo, adiciona = false) {
      var arr = this.status.filter(
        (x) => x.tipoStatus == null || x.tipoStatus == tipo
      );

      if (tipo == "Propostas") {
        arr = arr.filter((x) => x.tipoStatus == tipo);
      }

      if (adiciona == true) {
        arr.push({
          idDistribuidorArvoreComissao: null,
          nomeStatus: "Sem Alteração",
        });
      }
      return arr;
    },
    deleteArvore() {
      this.$vs.loading();
      var objSend = [];
      objSend.push(this.idDelete);
      console.log(objSend);
      service
        .post("DistribuidorPadraoMensageria", "Inativar", objSend)
        .then((res) => {
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: "Regra Deletada com sucesso",
            color: "success",
          });
          this.popDeleteArvore = false;
          this.idDelete = null;
          this.buscaDados();
        })
        .catch((e) => {
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: e,
            color: "danger",
          });
          this.$vs.loading.close();
        });
    },
    buscaDados(tipo = "ativo") {
      this.popUpdate = false;
      this.objUpdate = null;

      this.$vs.loading();
      service
        .getAll("DistribuidorPadraoMensageria", {}, "Listar/" + tipo)
        .then((res) => {
          console.log(res.data);
          this.regras = [];
          if (res.data.length > 0) {
            console.log(res.data);
            res.data.forEach((element) => {
              this.regras.push(element);
            });

            this.$vs.loading.close();
          } else {
            this.$vs.loading.close();
          }
          this.$forceUpdate();
        })
        .catch((e) => {
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: e,
            color: "danger",
          });
          this.$vs.loading.close();
        });
    },

    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll("g", {}, `${model}/list/`).then((res) => {
        res.data.forEach((element) => {
          this[array].push({
            id: element[campoPK],
            label: element[campoDescricao],
          });
        });
      });
    },
  },
  mounted() {
    this.$validator.localize("ptBr", locale);
    this.buscaDados();
  },
};
</script>
<style>
.vdp-datepicker input {
  width: 100%;
}
</style>

<style scoped lang="scss">
.table-bordered {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: grey;
  width: 100%;
  tr td {
    padding: 2px;
  }
  tr:nth-child(2n) {
    background: #efefef !important;
  }
}

.forceWhite:hover {
  color: #fff !important;
}
</style>
